import React from 'react';
import {connect} from 'react-redux';

import {T} from 'Actions/translate';
import DynamicCounter from 'Components/counter/DynamicCounter';
import util from 'Utils/commonUtil';
import {openNotification} from 'Actions/notification';
import {ExpandMore} from '@material-ui/icons';

class ShipmentLotCard extends React.Component {
    state = {
        previewReceiveImageDialogOpened: false,
        quantity: 0,
    };

    singleHandleCheck = (index, event) => {
        this.props.receiveSingleHandleCheck(index, event);
    };

    expandMoreLot = (lotSku) => {
        const {parentSku} = this.props;
        if (
            document.getElementsByClassName(
                'not-suggest-' + parentSku + '-' + lotSku,
            ).length > 0
        ) {
            let oParent = document.getElementsByClassName(
                'not-suggest-' + parentSku + '-' + lotSku,
            );
            for (let i = 0; i < oParent.length; i++) {
                oParent[i].style.display = 'block';
                if (i === oParent.length - 1) {
                    document.getElementById(
                        parentSku + '-' + lotSku,
                    ).style.display = 'none';
                }
            }
        }
    };

    isShowDisplayAllLotLabel = (shipmentLotInfor) => {
        let isShowAllLotLabel = true;
        if (shipmentLotInfor && shipmentLotInfor.length > 0) {
            shipmentLotInfor.map((shipmentLotItem, shipmentLotIndex) => {
                if (!shipmentLotItem.suggestFlag) {
                    isShowAllLotLabel = false;
                }
            });
        }
        return isShowAllLotLabel;
    };

    showLotInforamation = (lotItem) => {
        const {kitFlag, parentSku} = this.props;
        let shipmentLotInfor = [];
        let lotSku = 0;
        if (!(lotItem.length > 0)) {
            lotSku = lotItem.sku;
        } else {
            lotSku = lotItem[0].sku;
        }
        if (kitFlag) {
            shipmentLotInfor = lotItem.inventoryDetails;
        } else {
            shipmentLotInfor = lotItem;
        }
        return (
            <ul className="shipment-lot-container parent-package-ul">
                {shipmentLotInfor && shipmentLotInfor.length > 0
                    ? shipmentLotInfor.map(
                          (shipmentLotItem, shipmentLotIndex) => (
                              <li
                                  className={
                                      shipmentLotItem.suggestFlag
                                          ? 'parent-shipment-lot-li li-' +
                                            parentSku +
                                            '-' +
                                            shipmentLotItem.sku
                                          : 'parent-shipment-lot-li not-suggest-li not-suggest-' +
                                            parentSku +
                                            '-' +
                                            shipmentLotItem.sku
                                  }
                                  key={shipmentLotIndex}>
                                  <div className="childen-row">
                                      <div className="childen-first-column item-column lot-column">
                                          {T('host_advent_products_item')}
                                          <span className="parent-first-column-value">
                                              {shipmentLotItem.sku}
                                              {shipmentLotItem.suggestFlag ? (
                                                  <div className="lot-recommend-flag">
                                                      {T(
                                                          'shipment_recommended_label',
                                                      )}
                                                  </div>
                                              ) : null}
                                          </span>
                                      </div>

                                      <div className="childen-second-column shipment-lot-counter">
                                          {/* <Counter defalutValue={shipmentLotItem.suggestFlag ? shipmentLotItem.suggestQuantity : 0} currentSkuIndex={1} inputValid={value => this.inputValid('quantity', value, shipmentLotItem.id, shipmentLotItem) } options={{ min: 0 }}/> */}
                                          <DynamicCounter
                                              disabledFlag={
                                                  shipmentLotItem.mandatoryFlag
                                              }
                                              testid="shipment-pending-quantity"
                                              numberSteps={1}
                                              defalutValue={
                                                  shipmentLotItem.suggestFlag
                                                      ? shipmentLotItem.suggestQuantity
                                                      : 0
                                              }
                                              currentSkuIndex={1}
                                              inputValid={(value) =>
                                                  this.inputValid(
                                                      'quantity',
                                                      value,
                                                      shipmentLotItem.id,
                                                      shipmentLotItem,
                                                  )
                                              }
                                              options={{min: 0}}
                                          />
                                      </div>
                                  </div>
                                  <div className="childen-row">
                                      <div className="childen-first-column">
                                          {T('shipment_lot')}
                                          <span
                                              className="parent-first-column-value highlighted-lot"
                                              testid="shipment-detail-lot">
                                              {shipmentLotItem.lot}
                                          </span>
                                      </div>

                                      <div className="childen-second-column">
                                          {T(
                                              'host_advent_products_expiration_date',
                                          )}
                                          <span className="parent-first-column-value">
                                              {
                                                  shipmentLotItem.lotExpirationDate
                                              }
                                          </span>
                                      </div>
                                  </div>
                                  <div className="childen-row">
                                      <div className="childen-first-column">
                                          {T(
                                              'fone_order_current_inventory_colon',
                                          )}
                                          <span className="parent-first-column-value">
                                              {
                                                  shipmentLotItem.physicalInventory
                                              }
                                          </span>
                                      </div>

                                      <div className="childen-second-column">
                                          {T('host_advent_products_dnsa')}
                                          <span className="parent-first-column-value">
                                              {shipmentLotItem.dnsaDate}
                                          </span>
                                      </div>
                                  </div>
                              </li>
                          ),
                      )
                    : null}
                {!this.isShowDisplayAllLotLabel(shipmentLotInfor) ? (
                    <div
                        className="show-all-lot"
                        id={parentSku + '-' + lotSku}
                        onClick={() => this.expandMoreLot(lotSku)}>
                        {T('shipment_all_lot')}
                        <ExpandMore />
                    </div>
                ) : null}
            </ul>
        );
    };

    inputValid = (key, value, subLotId, shipmentLotItem) => {
        // if (value > shipmentLotItem.physicalInventory) {
        //     this.props.openNotification(T('shipment_quantity_out_current_inventory'), 'danger');
        // } else {
        // }
        this.setState({[key]: value});
        if (util.isFunction(this.props.inputValid)) {
            this.props.inputValid(key, value, subLotId);
        }
    };

    render() {
        const {shipmentLots, kitFlag} = this.props;
        return (
            <div>
                {kitFlag ? (
                    shipmentLots &&
                    shipmentLots.length > 0 &&
                    shipmentLots.map((lotItem, lotIndex) => (
                        <div
                            key={lotIndex}
                            className="shipment-order-infor-container">
                            <div className="lot-infor">
                                <div className="first-row">{lotItem.sku}</div>
                                <div className="second-row">
                                    <div>
                                        {T(
                                            'host_advent_product_specifications',
                                        )}
                                        {lotItem.specifications}
                                    </div>
                                    <div>
                                        {T('shippment_current_inventory_colon')}
                                        {lotItem.physicalInventory}
                                    </div>
                                    <div>
                                        {T('not_shippment_quantity_colon')}
                                        {lotItem.tobeShippedQuantity}
                                    </div>
                                </div>
                                <div className="third-row">
                                    <div>
                                        {T('storeCondition')}:{' '}
                                        {lotItem.storeCondition}
                                    </div>
                                    <div>
                                        {T('fone_order_shipping_condition')}:{' '}
                                        {lotItem.shippingCondition}
                                    </div>
                                </div>
                            </div>
                            {this.showLotInforamation(lotItem)}
                        </div>
                    ))
                ) : (
                    <div className="shipment-order-infor-container">
                        {this.showLotInforamation(shipmentLots)}
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, localData} = state;
    return {
        shipmentOrOrderDetails: host.shipmentOrOrderDetails,
        skuInventoryDetails: host.skuInventoryDetails,
        localData,
    };
};

const mapDispatchToProps = {
    openNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentLotCard);
